var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrykerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Stryker_Logo",
    "data-name": "Stryker Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 239.092,
    height: 60,
    viewBox: "0 0 239.092 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 239.092,
    height: 60,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M61.391,41.94c-2.854,0-4.705-.746-4.727-3.13.022-1.378,0-18.073,0-18.073H68.587V12.012H56.663V0h-8.7V12.012H17.805s-12.3-.524-12.3,11.867c0,12.35,12.3,11.827,12.3,11.827h14.61A2.955,2.955,0,0,1,35.5,38.821a2.988,2.988,0,0,1-3.088,3.127H0v8.719H32.282s12.494.549,12.494-11.873c0-12.068-12.494-11.815-12.494-11.815H17.738a2.974,2.974,0,0,1-3.085-3.119,2.979,2.979,0,0,1,3.085-3.123c2.6.01,30.233,0,30.233,0l-.006,18.073S46.92,50.667,59.354,50.667h9.232V41.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M234.212,53.267h8.727V47.551c0-12.219-12.07-11.706-12.07-11.706l-16.238,0V74.5h8.833l-.006-29.619,7.372-.01c2.235.007,3.383,1.279,3.383,3.793Z",
    transform: "translate(-142.751 -23.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M648.972,53.267H657.7V47.551c0-12.219-12.07-11.706-12.07-11.706l-16.238,0V74.5h8.833l-.006-29.619,7.372-.01c2.236.007,3.383,1.279,3.383,3.793Z",
    transform: "translate(-418.607 -23.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M297.283,75.121v8.716h10.974a12.587,12.587,0,0,0,7.093-1.861c4.191-2.5,6.241-8.889,6.714-10.5.554-1.93,10.663-35.616,10.663-35.616h-9.638l-7.59,27.4-7.6-27.4h-9.639L308.987,71.47l.277.895c.405,1.292-.17,2.744-1.512,2.756Z",
    transform: "translate(-197.722 -23.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M419.882,26.659V0h-8.717V50.667h8.717V39.8l4.944-6.163,9.593,17.034H444.4L431.046,26.878l12.271-14.868H431.967Z",
    transform: "translate(-273.465 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M541.849,54.609a19.036,19.036,0,0,0-19.308-19.39c-12.037.214-19.446,8.72-19.446,19.409.006,10.525,8.12,19.462,18.848,19.46h12.583V65.365h-11.8c-4.508,0-9.468-3.269-10.037-7.316l28.852,0a19.2,19.2,0,0,0,.309-3.443M512.687,50.44c.736-3.4,5.3-6.79,9.854-6.79s8.911,3.062,9.853,6.79Z",
    transform: "translate(-334.607 -23.424)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrykerLogo);
export default __webpack_public_path__ + "static/media/Stryker Logo.06f890ad19cc6c70a2fd8fab5f0714d9.svg";
export { ForwardRef as ReactComponent };